import { FunctionComponent } from "react";

import Button from "@ui/components/cta/Button";
import CloseIcon from "@ui/components/icon/CloseIcon";
import PageHeader, {
  PageHeaderBaseConfig,
} from "@ui/components/layout/PageHeader";
import ThreeDotsMenu from "@ui/components/notifications/ThreeDotsMenu/ThreeDotsMenu";
import { useComponentConfig } from "@ui/context/component-config-context";
import theme from "@ui/themes/theme-contract.css";

import * as styles from "./NotificationsHeader.css";

interface TabIndexes {
  threeDots: number;
}

interface NotificationsHeaderProps {
  showGoToNotificationsPageLink?: boolean;
  onCloseNotifications?: () => void;
  tabIndexes: TabIndexes;
  /**
   * When true, renders the three-dots actions menu inline beside the title
   * instead of in the trailing actions group. Used when the surrounding
   * surface (e.g., the Verge drawer) places its own close affordance in the
   * top-right corner, which would otherwise overlap the menu.
   */
  inlineActions?: boolean;
}

const NotificationsHeader: FunctionComponent<NotificationsHeaderProps> = ({
  showGoToNotificationsPageLink = true,
  onCloseNotifications,
  tabIndexes,
  inlineActions = false,
}) => {
  const { headerSize } = useComponentConfig("notificationsList");

  const threeDotsMenu = (
    <ThreeDotsMenu
      showGoToNotificationsPageLink={showGoToNotificationsPageLink}
      tabIndex={tabIndexes.threeDots}
    />
  );

  return (
    <div className={styles.headerContainer}>
      <div className={styles.headerLeft}>
        <PageHeader
          className={styles.header}
          classNameTitle={styles.headerTitle}
          title="Notifications"
          size={headerSize as PageHeaderBaseConfig["size"]}
          headingLevel="h1"
        />
        {inlineActions && threeDotsMenu}
      </div>
      <div className={styles.headerRight}>
        {!inlineActions && threeDotsMenu}
        {onCloseNotifications && (
          <Button
            className={styles.popoverCloseButton}
            text=""
            iconLeft={<CloseIcon fill={theme.sys.color.subtle} />}
            displayType="cycloneSecondary"
            onClick={onCloseNotifications}
          />
        )}
      </div>
    </div>
  );
};

export default NotificationsHeader;
